import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { StoreService } from '../store.service';
var HomeWorkComponent = (function () {
    function HomeWorkComponent(route, router, el, apiService, commonService, storeService) {
        this.route = route;
        this.router = router;
        this.el = el;
        this.apiService = apiService;
        this.commonService = commonService;
        this.storeService = storeService;
        this.openFlag = 1; //是否隐私提交
        this.isOpenClass = 0; //是否公开课
        this.allQuestionsNumber = 1; //题目数量
        this.currentNumber = 1; //当前完成题目数量
        this.theme = 'sight'; //主题
        this.canSave = false; //是否可以保存
        this.isSave = false;
        this.clickAble = true; //防止多次点击
        this.isShowTip = false; //是都显示提示框
        this.isCollapse = true; //是否收拢
        this.isShowToast = false; //是否显示toast
        this.tipType = ""; //提示框类型
        this.uploadId = ''; //查询上传文件条件
        this.uploadDisabled = false; //是否允许上传
        this.isShowPreview = false; //是否显示预览
        this.isShowLoading = false; //是否显示loading
        this.isPopupEnter = false;
        this.isWechat = false; //是否微信
        this.isShowPopup = false;
        this.assetsRoute = '../../assets';
        this.saveError = false;
        this.isShowFinishTip = false; //是否完成题目
        this.isSlideFinal = false; //题目是否做完
        this.isShowBackDesc = false; //是否展示背景描述
        this.isNextQuestion = false; //是否解锁下一题
        this.headTitle = "";
        this.blankSave = true; //空保存  false : 不是空保存 true:是空保存
        this.isNeedCorrect = true; //试卷是否需要批改 默认需要
        this.showLoading = false;
    }
    HomeWorkComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.isWechat = this.commonService.isWeiXin();
        $('#userIdContainer').val(localStorage.getItem('userId'));
        this.route.params.subscribe(function (params) {
            _this.lpmapcId = params['lpmapcId'];
            _this.projectId = params['projectId'];
            _this.learningPathMetaId = params['learningPathMetaId'];
            console.log(_this.learningPathMetaId);
        });
        if (this.learningPathMetaId) {
            localStorage.setItem("learningPathMetaId", String(this.learningPathMetaId));
        }
        else {
            localStorage.setItem("learningPathMetaId", "");
        }
        localStorage.removeItem("moduleId");
        this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
            _this.exerciseGroup = result;
            _this.isNeedCorrect = _this.exerciseGroup.needCorrect === 1;
            // if(this.exerciseGroup.status === 10){
            //   this.commonService.learningPortEventLog({'eventType':'homework_myanswer','eventSubType':'mobile'}).then();
            // }
            _this.exerciseType = _this.exerciseGroup.homeworkAppendixList.length === 0 ? 1 : 5;
            _this.isShowMsg = _this.exerciseGroup.terminalType === 1 && _this.exerciseGroup.userApplyId;
            _this.blankSave = (_this.exerciseGroup.userAnswer && _this.exerciseGroup.userAnswer !== '') || (_this.exerciseGroup.userAppendixList != null && _this.exerciseGroup.userAppendixList.length > 0) ? false : true;
            _this.allQuestionsNumber = 1;
            _this.uploadId = _this.exerciseGroup['userAppendixList'] ?
                _this.exerciseGroup['userAppendixList'].map(function (o, i) { return o.id; }).join("|") : "";
            _this.getUploadFileList({
                'homeworkDuplicateId': _this.lpmapcId,
                'fileUploadIds': _this.uploadId
            }).then(function (result) {
                _this.uploadList = result['newFileList'];
                _this.oldUploadList = result['oldFileList'];
                _this.uploadDisabled = _this.uploadList.length >= 10 || _this.exerciseGroup.toolsHomeworkFlag && _this.uploadList.length === 1;
                _this.showLoading = true;
                _this.page = _this.exerciseGroup.status == 20 ? 'finish' : _this.exerciseGroup.status == 0 && ((!_this.exerciseGroup.backgroundDescription || _this.exerciseGroup.backgroundDescription == null) || (_this.uploadList && _this.uploadList.length)) ? 'answer' : 'list';
            });
            _this.pdfList = _this.exerciseGroup.homeworkAppendixList ? _this.exerciseGroup.homeworkAppendixList : [];
            _this.postData = _this.formatPostData(_this.exerciseGroup);
            _this.buttonTxt = '一共' + _this.allQuestionsNumber + '小题，立即作答';
            _this.titleText();
        });
    };
    HomeWorkComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        this.commonService.initPage({
            'backgroundColor': 'rgba(40,51,130,1)'
        });
        $('body').css('height', 'auto');
        $('#wx-open-wrap').css('left', '-200%');
        // $('#wx-open-wrap').show();
    };
    HomeWorkComponent.prototype.ngOnDestroy = function () {
        localStorage.removeItem("exerciseGroup");
        localStorage.removeItem("uploadList");
        localStorage.removeItem("pdfList");
        localStorage.removeItem("uploadId");
        localStorage.removeItem("canSave");
    };
    //背景描述
    HomeWorkComponent.prototype.backgroundDesc = function () {
        this.isShowBackDesc = !this.isShowBackDesc;
    };
    /**
     * 设置头部的文本
     */
    HomeWorkComponent.prototype.titleText = function () {
        if (this.page === 'list') {
            this.headTitle = "";
        }
        else if (this.page === 'answer') {
            this.headTitle = this.currentNumber + "/" + this.allQuestionsNumber;
        }
    };
    /**
     * 格式化保存数据
     * @param item  传入的对象
     */
    HomeWorkComponent.prototype.formatPostData = function (item) {
        return {
            'homeworkDuplicateId': this.lpmapcId,
            'selector': item.userAnswer,
            'fileUploadIds': this.uploadId,
            'openFlag': this.openFlag,
            'terminalType': 2,
            'status': item.status
        };
    };
    //获取练习册本体的高度
    HomeWorkComponent.prototype.setBodyHeight = function (event) {
        this.bodyHeight = event + 'rem';
    };
    /**
     * 进入答题页面
     * @param status:Number  进入答题页面状态（0：立即作答 1：编辑）
     */
    HomeWorkComponent.prototype.goAnswer = function (status) {
        var _this = this;
        this.clickAble = true;
        this.currentNumber = 1;
        this.tipType = "";
        this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
            _this.exerciseGroup = result;
            _this.allQuestionsNumber = 1;
            _this.postData = _this.formatPostData(_this.exerciseGroup);
            _this.blankSave = (_this.exerciseGroup.userAnswer && _this.exerciseGroup.userAnswer !== '') || (_this.exerciseGroup.userAppendixList != null && _this.exerciseGroup.userAppendixList.length > 0) ? false : true;
            _this.pageChangedInit('sight', 'answer', 'rgba(40,51,130,1)', 'linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
            _this.titleText();
        });
    };
    //保存
    HomeWorkComponent.prototype.saveAnswer = function (page) {
        var _this = this;
        if (!this.clickAble)
            return;
        this.clickAble = false;
        if (this.blankSave) {
            this.clickAble = true;
            return false;
        }
        else {
            this.postData.status = 10;
            this.exerciseCommitAPI(this.postData, this.exerciseType).then(function (result) {
                // this.blankSave = true;
                _this.clickAble = true;
                if (page === 'list') {
                    _this.exit();
                    return;
                }
                if (_this.page === 'answer') {
                    _this.isShowToast = true;
                    _this.toastType = 3;
                    _this.tipType = 'save';
                    setTimeout(function () {
                        _this.isShowToast = false;
                    }, 1500);
                }
            }).catch(function (err) {
                if (err['error']['code'] === 101) {
                    _this.saveError = true;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err['error']['msg'];
                    _this.tipType = "";
                    setTimeout(function () {
                        _this.saveError = false;
                        _this.clickAble = true;
                        _this.isShowToast = false;
                    }, 1500);
                }
            });
        }
    };
    //提示框继续
    HomeWorkComponent.prototype.tipsContinue = function () {
        var _this = this;
        console.log('项目作业数据postData', this.postData);
        console.log('项目作业数据this.exerciseGroup', this.exerciseGroup);
        if (this.postData.status >= 20) {
            console.log('该项目作业已提交过', this.postData);
            return;
        }
        if (!this.clickAble)
            return;
        this.clickAble = false;
        if (this.tipType === 'save') {
            this.clickAble = true;
            this.blankSave = false;
            this.saveAnswer('list');
            this.isShowTip = false;
        }
        else if (this.tipType === 'finish') {
            this.postData.status = 20;
            this.exerciseCommitAPI(this.postData, this.exerciseType).then(function (result) {
                _this.clickAble = true;
                _this.isShowTip = false;
                _this.isPopupEnter = false;
                _this.isShowBackDesc = false;
                _this.pageChangedInit('sight', 'finish', 'rgba(246,246,246,1)', 'linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
                setTimeout(function () {
                    _this.isShowPopup = false;
                    _this.commonService.initPage({ 'backgroundColor': 'rgba(246,246,246,1)' });
                }, 100);
            }).catch(function (err) {
                if (err['error']['code'] === 101) {
                    _this.saveError = true;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err['error']['msg'];
                    setTimeout(function () {
                        _this.saveError = false;
                        _this.clickAble = true;
                        _this.isShowToast = false;
                    }, 1500);
                }
            });
        }
    };
    //获取用户隐私选项
    HomeWorkComponent.prototype.getUserOpenFlag = function (event) {
        this.openFlag = event;
    };
    //完成练习题
    HomeWorkComponent.prototype.finishExercise = function (tabNum) {
        var path = ['home-work-show', this.lpmapcId];
        if (this.learningPathMetaId) {
            this.router.navigate(path, { queryParams: { learningPathMetaId: this.learningPathMetaId, tabNum: tabNum } });
        }
        else {
            this.router.navigate(path, { queryParams: { projectId: this.projectId, tabNum: tabNum } });
            // alert('正在施工中...');
            // this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.lpmapcId,'tabNum':tabNum,'responseType':1}}).then();
        }
    };
    //提交答案
    HomeWorkComponent.prototype.commitAnswer = function (status) {
        var that = this;
        var flag = false;
        if (that.exerciseType === 1) {
            console.log(that.postData.selector);
            flag = that.postData.selector ? true : false;
        }
        else if (that.exerciseType === 5) {
            flag = that.postData.selector || that.postData.fileUploadIds && that.postData.fileUploadIds !== "" ? true : false;
        }
        if (flag) {
            that.tipType = 'finish';
            that.isShowPopup = true;
            setTimeout(function () {
                that.isPopupEnter = true;
            }, 300);
        }
        else {
            that.isShowToast = true;
            that.toastType = 0;
        }
        setTimeout(function () {
            that.isShowToast = false;
        }, 2000);
        if (that.isWechat && that.isShowPopup) {
            try {
                $('#wx-open-wrap').css('left', '5%');
                var btn = document.getElementById('subscribe-btn');
                btn.addEventListener('success', function (e) {
                    $('#wx-open-wrap').css('left', '-200%');
                    that.isPopupEnter = false;
                    setTimeout(function () {
                        that.isShowPopup = false;
                        that.tipsContinue();
                    }, 100);
                });
                btn.addEventListener('error', function (e) {
                    $('#wx-open-wrap').css('left', '-200%');
                    that.isPopupEnter = false;
                    setTimeout(function () {
                        that.isShowPopup = false;
                        that.tipsContinue();
                    }, 100);
                });
            }
            catch (e) {
                console.log('error', e.message);
                $('#wx-open-wrap').css('left', '-200%');
                that.isPopupEnter = false;
                setTimeout(function () {
                    that.isShowPopup = false;
                    that.tipsContinue();
                }, 100);
            }
        }
    };
    //是否可以保存（不能保存不出现弹窗提示，可以保存出现弹窗提示）
    HomeWorkComponent.prototype.getCanSave = function (event) {
        this.canSave = event;
        localStorage.setItem("canSave", JSON.stringify(this.canSave));
    };
    //获取子组件提交的练习答案
    HomeWorkComponent.prototype.getPostData = function (event) {
        var _this = this;
        this.postData.selector = event.selector;
        this.blankSave = (this.postData.selector !== '' && this.postData.selector != null) || this.postData.fileUploadIds ? false : true;
        if (event.wordOverrun) {
            this.isShowToast = true;
            this.toastType = 4;
            setTimeout(function () {
                _this.isShowToast = false;
            }, 2000);
        }
        console.log('获取子组件的答案：' + JSON.stringify(this.postData));
    };
    //页面切换时初始化背景
    HomeWorkComponent.prototype.pageChangedInit = function (theme, page, initColor, backgroundImage) {
        this.theme = theme;
        this.page = page;
        this.commonService.initPage({
            'backgroundColor': initColor,
            'backgroundImage': backgroundImage
        });
    };
    //返回
    HomeWorkComponent.prototype.exit = function () {
        var _this = this;
        if (this.page === 'list') {
            if (this.tipType !== "finish") {
                this.isShowFinishTip = true;
                this.isShowBackDesc = false;
            }
            else {
                var link = this.learningPathMetaId ? ['learning-path', this.learningPathMetaId] : ['learning-project', this.projectId];
                this.router.navigate(link).then();
            }
        }
        else if (this.page === 'answer') {
            this.isShowBackDesc = false;
            if (this.exerciseType == 5 || this.exerciseType == 1) {
                if (this.tipType == '' || this.tipType == 'finish') {
                    if (this.postData.selector != this.exerciseGroup.userAnswer) {
                        this.isShowTip = true;
                        this.tipType = 'save';
                    }
                    else {
                        var link = this.learningPathMetaId ? ['learning-path', this.learningPathMetaId] : ['learning-project', this.projectId];
                        this.router.navigate(link).then();
                    }
                }
                else if (this.tipType == 'save') {
                    this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
                        _this.exerciseGroup = result;
                        _this.postData = _this.formatPostData(_this.exerciseGroup);
                        _this.isShowTip = false;
                        _this.tipType = '';
                        var link = _this.learningPathMetaId ? ['learning-path', _this.learningPathMetaId] : ['learning-project', _this.projectId];
                        _this.router.navigate(link).then();
                    });
                }
            }
        }
    };
    //提示框退出
    HomeWorkComponent.prototype.closeComponentTip = function () {
        var _this = this;
        console.log("不保存");
        this.openFlag = 1;
        this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
            _this.exerciseGroup = result;
            _this.isShowTip = false;
            var link = _this.learningPathMetaId ? ['learning-path', _this.learningPathMetaId] : ['learning-project', _this.projectId];
            _this.router.navigate(link).then();
            _this.postData = _this.formatPostData(_this.exerciseGroup);
            _this.titleText();
        });
    };
    HomeWorkComponent.prototype.unFinishExit = function () {
        var link = this.learningPathMetaId ? ['learning-path', this.learningPathMetaId] : ['learning-project', this.projectId];
        this.router.navigate(link).then();
    };
    HomeWorkComponent.prototype.continue = function () {
        this.isShowFinishTip = false;
    };
    /**
     * 关闭私密提交弹出层
     */
    HomeWorkComponent.prototype.closePopup = function () {
        var _this = this;
        this.openFlag = 1;
        this.tipType = '';
        this.isPopupEnter = false;
        setTimeout(function () {
            _this.isShowPopup = false;
        }, 100);
    };
    /**
     * 预览
     * @param event:Object   子组件传递来的预览对象
     */
    HomeWorkComponent.prototype.showReview = function (event) {
        this.previewSource = event;
        this.isShowPreview = true;
    };
    /**
     * 关闭预览
     */
    HomeWorkComponent.prototype.closePreview = function () {
        this.isShowPreview = false;
    };
    /**
     * 接受子组件传递过来的需要删除文件的下标并删除该文件
     * @param event: Object   子组件传递来的数据
     */
    HomeWorkComponent.prototype.deleteUploadFile = function (event) {
        var _this = this;
        this.uploadList = this.uploadList.filter(function (item, i) { return i !== event['index']; });
        this.uploadDisabled = this.uploadList.length >= 10;
        var campFileUploadIds = '';
        this.uploadList.forEach(function (item, i) {
            campFileUploadIds = i !== _this.uploadList.length - 1 ? campFileUploadIds + item['id'] + '|' : campFileUploadIds + item['id'];
        });
        this.postData.status = 10;
        this.postData.fileUploadIds = campFileUploadIds;
        this.exerciseCommitAPI(this.postData, this.exerciseType).then(function (result) {
            _this.uploadId = _this.postData.fileUploadIds;
            // this.uploadId = result['userAppendixList'] ?
            //   result['userAppendixList'].map((o,i)=>{return o.id}).join("|") : "";
            _this.blankSave = _this.postData.selector && _this.postData.selector !== '' ? false : true;
        });
    };
    /**
     * 文件上传
     * @param files: files 上传的文件
     */
    HomeWorkComponent.prototype.fileUpload = function (files) {
        var _this = this;
        if (navigator.onLine) {
            this.fileUploadAPI({ 'files': files['files'], 'id': this.lpmapcId }).then(function (result) {
                _this.uploadId = _this.uploadId === "" ? result.id : _this.uploadId + '|' + result.id;
                _this.postData.fileUploadIds = _this.uploadId;
                console.log('上传文件的id是：' + _this.uploadId);
                $(files.el).attr('type', 'file');
            }).then(function () {
                return _this.getUploadFileList({
                    'homeworkDuplicateId ': _this.lpmapcId,
                    'fileUploadIds': _this.uploadId
                }).then(function (result) {
                    return _this.uploadList = result['newFileList'];
                });
            }).then(function () {
                _this.oldUploadList = _this.oldUploadList ? _this.oldUploadList : [];
                _this.uploadDisabled = _this.uploadList.length >= 10 || _this.exerciseGroup.toolsHomeworkFlag && _this.uploadList.length === 1;
                _this.blankSave = (_this.postData.selector !== '' && _this.postData.selector != null) || _this.postData.fileUploadIds ? false : true;
            });
        }
        else {
            this.isShowToast = true;
            this.toastType = 2;
            this.errTxt = '保存失败，请检查你的网络设置';
            setTimeout(function () {
                _this.isShowToast = false;
                $('#upload_input').attr('type', 'file');
            }, 2000);
        }
    };
    /**
     * 下载PDF文件
     * @param url: Number PDF's URL
     */
    HomeWorkComponent.prototype.downloadPDF = function (url) {
        this.downloadUrl = url;
        window.open(url);
        // window.open('ddilearner/v2/camp/applicationPractice/actualOperation/downloadFile/' + id)
    };
    /**
     * 根据试卷ID获取当前试卷所有小题题目
     * @param lpmapcId: Number  试卷Id
     */
    HomeWorkComponent.prototype.getExerciseDetailAPI = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/project/homework?homeworkDuplicateId=' + lpmapcId,
        }).toPromise();
    };
    /**
     * 提交答案
     * @param postData: JSONObject 作答数据
     * @param exerciseType: Number 作业类型
     */
    HomeWorkComponent.prototype.exerciseCommitAPI = function (postData, exerciseType) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': 'ddilearner/v2/user/project/homework/saveAnswers'
        }).toPromise();
    };
    /**
     * 根据第一题选择的选项id获取PDF文件
     * @param postData: JSONObject 选择题选项
     */
    HomeWorkComponent.prototype.getExercisePdfAPI = function (postData) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
        }).toPromise();
    };
    /**
     * 获取上传文件列表
     * @param postData: JSONObject 查询文件条件对象
     */
    HomeWorkComponent.prototype.getUploadFileList = function (postData) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': 'ddilearner/v2/user/project/homework/getHomeworkFileList',
        }).toPromise();
    };
    /**
     * 文件上传
     * @param data: Object 上传文件需要的参数
     */
    HomeWorkComponent.prototype.fileUploadAPI = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: 'ddilearner/v2/user/project/homework/' + _this.lpmapcId + '/fileUpload',
                type: 'POST',
                cache: false,
                data: data['files'],
                processData: false,
                contentType: false,
                headers: {
                    'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                    'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
                },
                beforeSend: function (XMLHttpRequest) {
                    _this.isShowLoading = true;
                },
                success: function (res) {
                    resolve(res);
                    setTimeout(function () {
                        _this.isShowLoading = false;
                        $('#upload_input').attr('type', 'file');
                    }, 500);
                },
                error: function (err) {
                    if (err.status === 401 && Number(err.responseJSON.code) === 106) {
                        _this.storeService.notification.notAuthed.next(true);
                    }
                    _this.isShowLoading = false;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err.status === 413 ? '保存失败，请上传小于10M文件！' : err['responseJSON']['msg'];
                    setTimeout(function () {
                        _this.isShowToast = false;
                        $('#upload_input').attr('type', 'file');
                    }, 2000);
                }
            });
        });
    };
    /**
     * 删除上传文件
     * @param data: Object 删除文件需要的参数
     */
    HomeWorkComponent.prototype.deleteUploadFileAPI = function (data) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/deleteCampUploadFile',
            'data': data
        }).toPromise();
    };
    return HomeWorkComponent;
}());
export { HomeWorkComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work.component.ts.pre-build-optimizer.js